import request from '@/router/axios'

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/report/custom' : '/report/custom'

export function conditions(data) {
  return request({
    url: urlPrefix + '/conditions',
    method: 'post',
    data
  })
}

export function save(data) {
  return request({
    url: urlPrefix + '/save',
    method: 'post',
    data
  })
}

export function remove(data) {
  return request({
    url: urlPrefix + '/delete',
    method: 'post',
    data
  })
}

export function list(data) {
  return request({
    url: urlPrefix + '/list',
    method: 'post',
    data
  })
}

export function getShowItem(data) {
  return request({
    url: urlPrefix + '/item',
    method: 'post',
    data
  })
}

export function editShowItem(data) {
  return request({
    url: urlPrefix + '/item/edit',
    method: 'post',
    data
  })
}

export function getDetail(data) {
  return request({
    url: urlPrefix + '/detail',
    method: 'post',
    data
  })
}

export function exportAvg(data) {
  return request({
    url: urlPrefix + '/avg/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}
